<!-- <a *ngIf="_userRoles.includes('MANAGE_AUDIT') || _userRoles.includes('admin')"> -->
<a >
  <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px; margin-left: 10;" matTooltip="Excel Datei erstellen mit Vorgängen bzgl. Projektgrupppenrollen für den angezeigten Benutzer" (click)="exportAuditData()">Export Audit Log</button>
</a>

<!-- <div style="max-height: 80%; overflow-y: auto;"> -->
<div style="overflow-y: auto;">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" style="height: calc(100vh - 350px); overflow-y: auto;">
    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <!-- use a disabled button to provide padding for tree leaf -->
      <button mat-icon-button disabled></button>
      {{node.name}}
    </mat-tree-node>
    <!-- This is the tree node template for expandable nodes -->
    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
      <button mat-icon-button matTreeNodeToggle
              [attr.aria-label]="'Toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
        </mat-icon>
      </button>
      {{node.name}}
    </mat-tree-node>
  </mat-tree>
</div>

